/**
 * For crypto pairs whose quote is not a stablecoin (e.g. ETHBTC), the data-provider
 * puts the <quote>USDT price on the tick as ea/eb. Once that tick factor is applied the
 * amount is in USDT, so the account rate has to be fetched for USDT instead of the
 * quote (ETHBTC price × BTCUSDT × USDT→EUR). The server defaults ea/eb to 1 when a
 * feed has no tick FX.
 */
const isTickFxValue = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 && n !== 1;
};

export const hasTickFx = (tick) => isTickFxValue(tick?.ea) || isTickFxValue(tick?.eb);

export const getFxQuoteAsset = (quoteAsset, tick) =>
  hasTickFx(tick) ? 'USDT' : String(quoteAsset || 'USD').toUpperCase();
